import React from 'react';
import { makeStyles } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
var useStyles = makeStyles(function (theme) { return ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}); });
var BackdropLoader = function (_a) {
    var open = _a.open;
    var classes = useStyles({});
    return (React.createElement(Backdrop, { className: classes.backdrop, open: open },
        React.createElement(CircularProgress, null)));
};
export default BackdropLoader;
//# sourceMappingURL=index.js.map